import { useMyLanguage, useShareLink } from 'app/_hooks'
import { useCallback } from 'react'
import { getLanguage } from '~/libs/language'
import * as GA from './ga'

export type ShareItemType = 'url' | 'x' | 'facebook'

interface ShareModalViewModal {
  onClickShareItem: (itemType: ShareItemType) => void
}

interface ShareModalViewModalProps {
  previewVideoId: string
  title: string
  description: string
}

export function useShareModalViewModal({
  previewVideoId,
  title,
  description,
}: ShareModalViewModalProps): ShareModalViewModal {
  const myLanguage = useMyLanguage()
  const { createShareLink } = useShareLink()

  const onClickShareItem = useCallback(
    async (item: ShareItemType) => {
      GA.shareItemClick(Number(previewVideoId))
      let url: string
      if (getLanguage(window.location.hostname) || myLanguage === undefined) {
        url = `${window.location.origin}/videos/${previewVideoId}`
      } else {
        const { protocol, hostname, port } = window.location
        const parts = hostname.split('.')
        if (parts[0] === 'www') {
          parts[0] = myLanguage
        } else {
          parts.unshift(myLanguage)
        }
        console.log(parts)

        url = `${protocol}//${parts.join('.')}${port ? `:${port}` : ''}/videos/${previewVideoId}`
      }

      switch (item) {
        case 'url':
          navigator.clipboard.writeText(await createShareLink(url, 'URL_COPY'))
          break
        case 'x':
          window.open(
            `https://x.com/intent/tweet?url=${encodeURIComponent(
              await createShareLink(url, 'X'),
            )}%0a&text=${title}%0a${description}%0a&hashtags=samansa`,
            '_blank',
          )
          break
        case 'facebook':
          window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              await createShareLink(url, 'FACEBOOK'),
            )}`,
            '_blank',
          )
          break
      }
    },
    [description, previewVideoId, title, myLanguage, createShareLink],
  )

  return { onClickShareItem }
}
